import { useQuery } from "@tanstack/react-query";
import { getAssignedProjects } from "../api/timeEntryApi";
import { timeEntryKeys } from "../api/timeEntryKeys";

// Obtiene los proyectos asignados para usuarios con permiso Estructura /
// Estructura Operativa. El parámetro `enabled` difiere la carga al abrir el dialog.
export const useAssignedProjects = (enabled = true) =>
  useQuery({
    queryKey: timeEntryKeys.assignedProjects(),
    queryFn: getAssignedProjects,
    enabled,
  });
